import { GraphqQlApi as api } from '@/api/api.js'
import indexedDBState from '@/tools/userAnalytics/IndexedDBState'

let isInitialise = false

export default {
  /**
   * The creating window events function.
   * Allows you to create native events to track browser behaviors
   */
  initializeEvents(userAnalyticsTools, route) {
    if (isInitialise) {
      return
    }
    function processAnalytics() {
      indexedDBState.getEvents().then((events) => {
        if (events && events.length > 0) {
          // Формирование данных из indexedDB
          let data = events.map((e) => {
            // Удалить id которое indexedDB ставит по умолчанию, а также передавать пустой args (Нужно для database)
            delete e.id
            return {...e, args: e.args || ''}
          })

          // Запрос к API
          api.addAnalytics(data).then((response) => {
            if (response.data.webAppModelerQueryMutation.addAnalytics.success) {
              // Полная очистка данных indexedDB в случае успеха
              indexedDBState.removeEvents()
            }
          })
        }
      })
    }

    processAnalytics()

    // Переодическая отправка данных с аналитики на бэк-энд (интервал 5 минут)
    setInterval(processAnalytics, 300000)

    /**
     * on close tab event.
     * we use simple function, and call saveSessionEndAction inside,
     * to not show the action confirmation window
     */
    window.onbeforeunload = function () {
      userAnalyticsTools.onSessionEndAction(route?.currentRoute?.name)
    }

    // on blur to the tab
    window.onblur = function () {
      userAnalyticsTools.onTabBlurAction(route?.currentRoute?.name)
    }

    // on focus to the tab
    window.onfocus = function () {
      userAnalyticsTools.onTabFocusAction(route?.currentRoute?.name)
    }
  }
}
